import React, { ReactElement } from 'react';
import { FullName } from 'b2b-apps/shop/common/components/Address/FullName/FullName';
import { ComponentType, Props } from './';

const Address: ComponentType = (props: Props): ReactElement | null => {
  const {
    className,
    name,
    contactPerson,
    firstName,
    lastName,
    salutation,
    street,
    streetAddition,
    postCode,
    city,
  } = props;

  if (
    !name
    && !contactPerson
    && !street
    && !streetAddition
    && !postCode
    && !city
  ) {
    return null;
  }

  return (
    <div className={className} data-hj-suppress>
      {name && <>{name}<br /></>}
      {contactPerson && <>{contactPerson}<br /></>}
      <FullName salutation={salutation} firstName={firstName} lastName={lastName} />
      {street && <>{street}<br /></>}
      {streetAddition && <>{streetAddition}<br /></>}
      {postCode} {city}
    </div>
  );
};

export { Address };
